// Vue instances
import Header from '@vue-instances/Header';

// Modules
import megaMenu from '@modules/megaMenu';
import mobileMenu from '@modules/mobileMenu';

export default function init() {
  Header();
  megaMenu();
  mobileMenu();
}
